<template>
  <v-container></v-container>
</template>

<script>
/* eslint-disable */
import SearchBoxService from '../../services/searchBox.service';

export default {
    created(){

        let sid = this.$route.params.sid;

        
        SearchBoxService.getSearchResultUrl(sid).then((result)=>{
            this.$store.commit('updateWholesaleIdAndUrlId',[result.data.wsid,result.data.urlid]);
            this.$router.push(
            {
                name:'FlightSearchForwarder',
                params:{
                    wsid:result.data.wsid,
                    urlid:result.data.urlid,
                    rqid:"SI"+sid,
                    mlv: result.data.mlv,
                }
            });         
        });
        

    },
}
</script>

<style>

</style>